var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("CargoMsg.Cargo_EditKeyWord"),
        "append-to-body": "",
        "close-on-click-modal": false,
        width: "400px"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        { attrs: { "label-width": "100px" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("Information.VerificationItem") } },
            [
              _c("el-input", {
                attrs: { disabled: "" },
                model: {
                  value: _vm.wordFieldTxt,
                  callback: function($$v) {
                    _vm.wordFieldTxt = $$v
                  },
                  expression: "wordFieldTxt"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("Information.SensitiveWords") } },
            [
              _c("el-input", {
                ref: "words",
                on: {
                  change: function(value) {
                    return (_vm.thresholdLength =
                      value.replace(/\s+/g, "").length - 1)
                  }
                },
                model: {
                  value: _vm.form.words,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "words", $$v)
                  },
                  expression: "form.words"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("CargoMsg.Cargo_ApplicationBranch1") } },
            [
              _c(
                "cargo-multiple-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    no: "multipleBranchId",
                    value: _vm.toArray(_vm.form.multipleBranchId),
                    filterable: "",
                    clearable: ""
                  },
                  on: { input: _vm.onMultipleBranchIdInput }
                },
                [
                  _c("el-option", {
                    key: -1,
                    attrs: { label: _vm.$t("Message.All"), value: "0" }
                  }),
                  _vm._l(_vm.officeList, function(item, index) {
                    return _c("el-option", {
                      key: index,
                      attrs: {
                        label: _vm.getOfficeLabel(item),
                        value: String(item.officeId)
                      }
                    })
                  })
                ],
                2
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("CargoMsg.Cargo_BusinessType") } },
            [
              _c(
                "cargo-multiple-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    no: "multipleLob",
                    value: _vm.toArray(_vm.form.multipleLob),
                    filterable: "",
                    clearable: ""
                  },
                  on: { input: _vm.onMultipleLobInput }
                },
                _vm._l(_vm.lobs, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: {
                      label: _vm.$selectByLang(
                        item.chineseName,
                        item.englishName
                      ),
                      value: item.code
                    }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("Information.SeaAirRoutes") } },
            [
              _c(
                "cargo-multiple-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    no: "multipleRegion",
                    disabled: !_vm.isSea && !_vm.isAir,
                    value: _vm.toArray(_vm.form.multipleRegion),
                    filterable: "",
                    clearable: ""
                  },
                  on: { input: _vm.onMultipleRegionInput }
                },
                [
                  _c("el-option", {
                    key: -1,
                    attrs: { label: _vm.$t("Message.All"), value: " " }
                  }),
                  _vm._l(_vm.regionList, function(item, index) {
                    return _c("el-option", {
                      key: index,
                      attrs: {
                        label: _vm.$selectByLang(item.name, item.nameEnglish),
                        value: item.code
                      }
                    })
                  })
                ],
                2
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("Information.AppliedSeaport") } },
            [
              _c("cargo-advance-select", {
                attrs: {
                  no: "multipleSeaPort",
                  disabled: !_vm.isSea,
                  filterable: "",
                  "select-type": _vm.TYPE_NAMES.basic_data_Seaport,
                  "static-options": _vm.seaportList,
                  "default-multiple-value": _vm.toArray(
                    _vm.form.multipleSeaPort
                  ),
                  multiple: true
                },
                on: { parentCallBack: _vm.onMultipleSeaPortInput }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("Information.AppliedShippingCompany") } },
            [
              _c("cargo-advance-select", {
                attrs: {
                  no: "multipleSeaCmp",
                  disabled: !_vm.isSea,
                  filterable: "",
                  "select-type": _vm.TYPE_NAMES.basic_data_Company,
                  "static-options": _vm.seaCmpList,
                  "default-multiple-value": _vm.toNumArray(
                    _vm.form.multipleSeaCmp
                  ),
                  multiple: true
                },
                on: { parentCallBack: _vm.onMultipleSeaCmpInput }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("Information.ApplicationAirport") } },
            [
              _c("cargo-advance-select", {
                attrs: {
                  no: "multipleAirPort",
                  disabled: !_vm.isAir,
                  filterable: "",
                  "select-type": _vm.TYPE_NAMES.basic_data_Airport,
                  "static-options": _vm.airportList,
                  "default-multiple-value": _vm.toArray(
                    _vm.form.multipleAirPort
                  ),
                  multiple: true
                },
                on: { parentCallBack: _vm.onMultipleAirPortInput }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("Information.AppliedAirlines") } },
            [
              _c("cargo-advance-select", {
                attrs: {
                  no: "multipleAirCmp",
                  disabled: !_vm.isAir,
                  filterable: "",
                  "select-type": _vm.TYPE_NAMES.basic_data_Company,
                  "static-options": _vm.airCmpList,
                  "default-multiple-value": _vm.toNumArray(
                    _vm.form.multipleAirCmp
                  ),
                  multiple: true
                },
                on: { parentCallBack: _vm.onMultipleAirCmpInput }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c("template", { slot: "label" }, [
                _c(
                  "span",
                  [
                    _vm._v(_vm._s(_vm.$t("Information.Threshold")) + " "),
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        staticStyle: { color: "#4AA4EA" },
                        attrs: {
                          content: _vm.$t("Information.ThresholdTip"),
                          placement: "top",
                          effect: "light"
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "el-icon-question",
                          staticStyle: {
                            "font-size": "16px",
                            "vertical-align": "middle"
                          }
                        })
                      ]
                    )
                  ],
                  1
                )
              ]),
              _c("el-input-number", {
                attrs: {
                  no: "threshold",
                  "controls-position": "right",
                  min: 0,
                  max: _vm.thresholdLength
                },
                model: {
                  value: _vm.form.threshold,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "threshold", $$v)
                  },
                  expression: "form.threshold"
                }
              })
            ],
            2
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: { "text-align": "center" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _vm.form.uuid
            ? _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.saveHandler } },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
              )
            : _vm._e(),
          _c("el-button", { on: { click: _vm.closeHandler } }, [
            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }